import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../../route';

export const createIncomingMobilityRoute = createRoute({
	getParentRoute: () => clientRoute,
	path: '/accounts/$accountIban/create-incoming-mobility',
});
